import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import Button from '../Button';
import './DefaultButton.scss';
import useIntlMessage from '@app/hooks/use-intl-message';

const DefaultButton = ({ className, onClick, locKey, hidden = false, disabled = false, secondary = false, ...props }) => {
  const [buttonContent] = useIntlMessage(locKey);
  return (
    <Button
      className={classnames('qau-default-button', className, { secondary })}
      onClick={onClick}
      disabled={disabled}
      hidden={hidden}
      locKey={locKey}
      aria-label={buttonContent}
      aria-disabled={disabled}
      {...props}
    />
  );
};

DefaultButton.propTypes = {
  className: PropTypes.string,
  locKey: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  hidden: PropTypes.bool,
  disabled: PropTypes.bool,
  secondary: PropTypes.bool,
};

export default DefaultButton;
